// HomePage.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './HomePage.css';

const HomePage = () => {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const links = [
    { id: 'kicpod', title: 'KICPod', color: '#def339' },
    { id: 'lifeuncut', title: 'Life Uncut', color: '#def339'},
    { id: 'mamamiaoutloud', title: 'Mamamia Out Loud', color: '#def339'},
    { id: 'shameless', title: 'Shameless', color: '#def339' },
    { id: 'styleish', title: 'Style-ish', color: '#def339'},
    { id: 'imperfects', title: 'The Imperfects', color: '#def339'},
    // { id: 'wedonthavetimeforthis', title: 'We Don\'t Have Time For This', color: '#def339'},
  ];

  const handleLinkClick = (linkTitle) => {
    ReactGA.event({
      category: 'User Interaction',
      action: 'Button Click',
      label: linkTitle
    });
  };

  return (
    <>
      <div className="homepage">
        <div className="links-container">
          {links.map((link) => (
            <Link 
              to={`/${link.id}`} 
              key={link.id}
              onClick={() => handleLinkClick(link.title)}
            >
              <button 
                className="link-button" 
                style={{ backgroundColor: link.color }}
              >
                {link.title}
              </button>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomePage;
